import React, { useEffect, useState } from 'react';

import { sortBy } from 'lodash';

import { OrgPositionDetail } from '@appTypes/esb/organizations/positions/_orgGuid';
import { InvalidPositions } from '@modules/permissionManager/constants';
import { useOrgPositions } from '@modules/permissionManager/duck/hooks';
import { Select } from '@shared/components';
import { intl } from '@shared/localization';

const { Option } = Select;

interface Props {
  className?: string;
  globalPositionsFilter?: string[];
  onPositionFilterChange: (value: string[]) => void;
}

export const PermsPanelFilterCard: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  globalPositionsFilter,
  onPositionFilterChange,
}) => {
  const { isFetching: isLoadingOrgPositions, data: orgPositionsData } =
    useOrgPositions();
  const [positionOptions, setPositionOptions] = useState<OrgPositionDetail[]>(
    [],
  );
  const [selectedPositions, setSelectedPositions] = useState<string[]>([]);

  useEffect(() => {
    const positions = orgPositionsData?.Positions;

    if (positions?.length) {
      const filteredPositions = positions.filter(
        pos =>
          !pos.isFunctional &&
          !pos.isYouthPosition &&
          !(pos.min === 0 && pos.max === 0) &&
          !InvalidPositions.includes(pos.positionLong),
      );

      setPositionOptions(sortBy(filteredPositions, 'positionLong'));
    }
  }, [orgPositionsData]);

  useEffect(() => {
    if (globalPositionsFilter) {
      setSelectedPositions(globalPositionsFilter);
    }
  }, [globalPositionsFilter]);

  const handleSelectPosition = (value: string) => {
    const updated = [...selectedPositions, value];
    setSelectedPositions(updated);
    onPositionFilterChange(updated);
  };

  const handleDeselectPosition = (value: string) => {
    const updated = selectedPositions.filter(item => item !== value);
    setSelectedPositions(updated);
    onPositionFilterChange(updated);
  };

  return (
    <Select
      placeholder={intl.formatMessage({
        id: 'permissionManager.permissionTab.filterByPosition',
      })}
      size="large"
      optionFilterProp="text"
      rounded
      showArrow
      mode="multiple"
      className={className}
      loading={isLoadingOrgPositions}
      value={selectedPositions}
      onSelect={handleSelectPosition}
      onDeselect={handleDeselectPosition}
    >
      {positionOptions.map(({ positionLong, PositionId }) => (
        <Option
          key={`positionOption_${PositionId}`}
          value={positionLong}
          // @ts-expect-error Option component needs to update typedef to include text
          text={positionLong}
        >
          {positionLong}
        </Option>
      ))}
    </Select>
  );
};
